module.exports = __webpack_public_path__ + "img/1-2.7a1d15d8.png";